<template>
    <section class="home-about">
        
        <v-container>
            <v-row>
                <v-col>
                    <div class="section__title">
                        <div class="section__title-text">学校概要</div>
                    </div>
                </v-col>
            </v-row>
            <v-row class="home-about__contents" align="center">
                <v-col md="10" class="home-about__contents-text" align="center">
                    <p class="text-h6">松尾中学校の、校歌や校章、沿革などについてまとめています。</p>
                </v-col>
            </v-row>
            <AppButton 
                :button-text="buttonText" 
                :url="url"
            />
        </v-container>
    </section>
</template>

<script>
import AppButton from './AppButton.vue'

export default {
    name: 'HomeAbout',
    data () {
        return {
            buttonText: '詳しくみる',
            url: '/about'
        }
    },
    components: {
        AppButton
    }
}
</script>

<style scoped lang='scss'>
@import "../styles/common/common.scss";

.section__title-text {
  padding: 1rem 2rem;
  border-top: 3px solid #000;
  border-bottom: 3px solid #000;
  text-align:  center;
}
.home-about__contents {
  justify-content: center;
  &-text {
    word-wrap: break-word;
  }
}

</style>